import * as StoreInfoRequests from "../server/StoreInfoRequests";
import type {
	InvalidDeliveryDate,
	InvalidPickupDate,
	ValidDeliveryDate,
	ValidPickupDate,
} from "../server/StoreInfoRequests";
import type { ICartContextChangeConsumer } from "./CartContextChangeListener";
import { CustomerCartContextStore } from "./common-cart/CartContextStore";
import { CartContextChangeListener } from "./CartContextChangeListener";
import type { CartContext } from "./common-cart/CartContextStore";
export type DeliveryDates = Map<string, ValidDeliveryDate | InvalidDeliveryDate>;
export type PickupDates = Map<string, ValidPickupDate | InvalidPickupDate>;
type DeliveryDatesCartContext = {
	country: string;
	storeId: string;
	customerId: string;
	fsdAddressId: string;
};
type PickupDatesCartContext = {
	country: string;
	storeId: string;
};
export class DeliveryDatesProvider implements ICartContextChangeConsumer<DeliveryDates, DeliveryDatesCartContext> {
	extractContext = ({ country, storeId, customerId, fsdAddressId }: CartContext): DeliveryDatesCartContext | null => {
		if (!country || !storeId || !customerId || !fsdAddressId) return null;
		return {
			country,
			storeId,
			customerId,
			fsdAddressId,
		};
	};
	fetchData = async ({
		country,
		storeId,
		customerId,
		fsdAddressId,
	}: DeliveryDatesCartContext): Promise<DeliveryDates> => {
		const response = await StoreInfoRequests.getDeliveryDates({
			country,
			storeId,
			customerId,
			fsdAddressId,
		});
		return new Map(Object.entries(response.deliveryDates));
	};
}
export class PickupDatesProvider implements ICartContextChangeConsumer<PickupDates, PickupDatesCartContext> {
	extractContext = ({ country, storeId }: CartContext): PickupDatesCartContext | null => {
		if (!country || !storeId) return null;
		return {
			country,
			storeId,
		};
	};
	fetchData = async ({ country, storeId }: PickupDatesCartContext): Promise<PickupDates> => {
		const response = await StoreInfoRequests.getPickupDates({
			country,
			storeId,
		});
		return new Map(Object.entries(response.pickupDates));
	};
}
export const DeliveryDatesStore = new CartContextChangeListener(CustomerCartContextStore, new DeliveryDatesProvider());
export const PickupDatesStore = new CartContextChangeListener(CustomerCartContextStore, new PickupDatesProvider());
